import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import * as Func from '../../../../../helpers/functions';
import i18n from "../../../../../constants/initLng";

import * as tourPropertyAction from "../../../../../actions/tourPropertyAction";
import * as HMS from "../../../common/component/Index";
import { message, Tooltip, Icon, Checkbox } from 'antd';
import { merge, cloneDeep } from 'lodash';
import Input from '../../../common/component/Input';
import { DETAIL_ACTIONS, PATHS, FEATURE_FLAGS, DEFAULT_TOUR_PROPERTY, ORDER } from '../../../../../constants/Define';
import TranslateButton from '../../../common/component/TranslateButton';
import TourProperty from '../../../../../models/TourProperty';

const CheckboxGroup = Checkbox.Group

const defaultValue = {
    action: DETAIL_ACTIONS.CREATE,
    data: merge(new TourProperty(), { isEnabled: true }),
    isSubmit: false,
    isFetching: false,
    isFetchingUpdate: false,
    isGetItem: false,
    validation: {},
};

class ActionComponent extends Component {

    state = cloneDeep(defaultValue);

    componentDidMount() {
        const { match } = this.props;
        if (Object.keys(match.params).length > 0) {
            this.setState({ action: DETAIL_ACTIONS.UPDATE, data: cloneDeep(defaultValue.data) });
            this.props.onGetItemProperty({ id: match.params.id, props: this.props });
        }
    }

    validation = (field, reload) => {
        const { t } = this.props;
        let data = this.state.data;
        let result = {};
        if (!reload) {
            let validate = {
                required: {
                    name: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.property.name`)),
                    address: Func.formatValidation(t('validation.statusCode.code.1'), t(`item.property.address`))
                },
                isEmail: { email: t('validation.email') },
                isPhone: { phone: t('validation.isPhone') },
                minLength: { phone: t('validation.minPhone'), type: t('validation.type') },
                maxLength: { phone: t('validation.maxPhone') },
            };
            if(this.state.action === DETAIL_ACTIONS.CREATE) {
                validate.required.languageCode = Func.formatValidation(t('validation.statusCode.code.1'), t(`translate.defaultLanguage`));
            }
            let valueValidate = {
                minLength: { phone: 8, type: 1 },
                maxLength: { phone: 12 },
            };
            result = Func.multipleValidate(data, validate, valueValidate);
        } else {
            let validation = this.state.validation;
            result = Func.reloadValidation(validation, field)
        }
        this.setState({ validation: result });
        return result;
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            isSubmit: nextProps.tourProperties.isSubmit,
            isGetItem: nextProps.tourProperties.isGetItem,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.tourProperties.dataUpdate !== prevProps.tourProperties.dataUpdate) {
            this.setState({
                data: this.props.tourProperties.dataUpdate,
            })
        }
    }

    onShowTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        data.setData();
        this.setState({ data, action: DETAIL_ACTIONS.TRANSLATE });
    }

    onExitTranslate = () => {
        const data = cloneDeep(this.state.data);
        const action = DETAIL_ACTIONS[data.id ? 'UPDATE' : 'CREATE'];
        data.setTranslate(undefined, true);
        data.setData();
        this.setState({ data, action });
    }

    onClickBack = () => {
        if (this.state.action === DETAIL_ACTIONS.TRANSLATE) {
            this.onExitTranslate();
        } else {
            this.props.history.push(PATHS.TOUR_PROPERTIES.LIST.path);
        }
    }

    onSaveTranslate = (data) => {
        data = data || this.state.data;
        const translateFunction = data.translate.id ? this.props.updatePropertyTranslate : this.props.createPropertyTranslate;
        translateFunction(data, data.languageCode);
        this.onExitTranslate();
    }

    onRemoveTranslate = (language) => {
        const { data } = this.state;
        data.setTranslate(language.code);
        this.props.deletePropertyTranslate(data, { id: data.id });
    }

    onChange = (e) => {
        let params = Func.getValueForm(e);
        if (params.name === "phone") {
            params.value = params.value.replace(/\D/g, '');
        }
        this.setState({
            data: merge(this.state.data, {
                [params.name]: typeof params.value === 'string' ? params.value.trimLeft() : params.value,
            })
        });
        this.validation(params.name, true)
    };

    onSubmit = (e) => {
        e.preventDefault();
        let result = this.validation();
        if (Object.keys(result).length < 1) {
            if (this.state.action === DETAIL_ACTIONS.CREATE) {
                let dataCreate = this.state.data;
                if (dataCreate.email === "") {
                    dataCreate.email = undefined;
                }
                this.props.onCreateProperty({ data: dataCreate, props: this.props });
            } else if (this.state.action === DETAIL_ACTIONS.UPDATE) {
                let dataUpdate = this.state.data;
                if (dataUpdate.email === "") {
                    dataUpdate.email = undefined;
                }
                dataUpdate.id = this.state.data.id;
                this.props.onUpdateProperty({ data: dataUpdate, props: this.props });
            } else if(this.state.action === DETAIL_ACTIONS.TRANSLATE){
                this.onSaveTranslate()
            }
        } else {
            message.error(i18n.t('validation.checkForm'))
        }
    };

    onChangeCheckBox = list => {
        const newData = Object.assign(this.state.data, { type: list })
        this.setState({ data: newData })
    };

    render() {
        const { t } = this.props;
        const { data, validation, isSubmit, isGetItem, action } = this.state;
        return (
            <Fragment>
                <HMS.LoadingComponent spinning={isSubmit}>
                    <HMS.PageListComponent>
                        <HMS.HeaderListComponent
                            path={this.props.match.path}
                            groupPath="properties"
                            titleHeader={
                                action === DETAIL_ACTIONS.CREATE ?
                                    Func.capitalizeFirstLetter((`${t('action.create')} ${t('item.property.title')}`).toLowerCase())
                                    : Func.capitalizeFirstLetter((`${t('action.update')} ${t('item.property.title')}`.toLowerCase()))
                            }
                            componentRight={FEATURE_FLAGS.TRANSLATE_ENABLE &&
                                <TranslateButton
                                    languages={data.translations}
                                    current={data.languageCode}
                                    validation={validation.languageCode}
                                    onChange={this.onShowTranslate}
                                    onClear={this.onExitTranslate}
                                    defaultSelecting={action === DETAIL_ACTIONS.CREATE}
                                    onSelectDefault={language => this.onChange({name: 'languageCode', value: language.code})}
                                    onRemove={this.onRemoveTranslate} />
                            }
                        />
                        <HMS.FormActionComponent
                            onSubmit={this.onSubmit}
                            isSubmit={isSubmit}
                            action={action}
                            isGetItem={isGetItem}
                            findParentRoute={() => Func.findParentRoute('properties', this.props)}
                            onChangeActive={this.onChange}
                            submitButtonRight={true}
                            onClickBack={this.onClickBack}
                            backButtonText={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.cancel`) : t(`action.back`)}
                            titleButtonSubmit={action === DETAIL_ACTIONS.TRANSLATE ? t(`action.save`) : undefined}
                        >
                            <HMS.FormWrapperItem>
                                <div className="col-md-6 mt-3">
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.name}
                                        validation={validation.name}
                                        messageBelowInput={true}
                                        labelTitle={t(`item.property.name`)}
                                    >
                                        <Input placeholder="" type="text"
                                            className="form-control"
                                            name="name" onChange={this.onChange}
                                            value={Func.checkUndefine(data.name)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-6 mt-3">
                                    <HMS.FormWrapperInputComponent
                                        isRequired={true}
                                        isValidation={true}
                                        dataValidation={data.address}
                                        validation={validation.address}
                                        messageBelowInput={true}
                                        labelTitle={t(`item.property.address`)}
                                    >
                                        <Input placeholder=""
                                            className="form-control"
                                            name="address" onChange={this.onChange}
                                            value={Func.checkUndefine(data.address)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-6">
                                    <HMS.FormWrapperInputComponent
                                        isValidation={true}
                                        dataValidation={data.phone}
                                        validation={validation.phone}
                                        labelTitle={t(`item.property.phone`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Input placeholder="" type="text"
                                            className="form-control"
                                            name="phone" onChange={this.onChange}
                                            value={Func.checkUndefine(data.phone)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-6">
                                    <HMS.FormWrapperInputComponent
                                        isValidation={true}
                                        dataValidation={data.email}
                                        validation={validation.email}
                                        labelTitle={t(`item.property.email`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <Input placeholder=""
                                            className="form-control"
                                            name="email" onChange={this.onChange}
                                            value={Func.checkUndefine(data.email)} />
                                    </HMS.FormWrapperInputComponent>
                                </div>
                                <div className="col-md-6 m-t">
                                    <HMS.FormWrapperInputComponent
                                        isValidation={true}
                                        dataValidation={data.type}
                                        validation={validation.type}
                                        labelTitle={t(`item.property.type`)}
                                        visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                    >
                                        <div>
                                            <CheckboxGroup 
                                                className="m-t"
                                                options={DEFAULT_TOUR_PROPERTY} 
                                                value={data.type || []} 
                                                onChange={this.onChangeCheckBox} />
                                        </div>
                                    </HMS.FormWrapperInputComponent>
                                </div>
                            </HMS.FormWrapperItem>
                        </HMS.FormActionComponent>
                    </HMS.PageListComponent>
                </HMS.LoadingComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        tourProperties: state.tourPropertyReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onCreateProperty: (params) => {
            dispatch(tourPropertyAction.createPropertyAction(params))
        },
        onUpdateProperty: (id) => {
            dispatch(tourPropertyAction.updatePropertyAction(id))
        },
        onGetItemProperty: (id) => {
            dispatch(tourPropertyAction.getUpdatePropertyAction(id))
        },
        createPropertyTranslate: (group, language) => dispatch(tourPropertyAction.createPropertyTranslate(group, language)),
        updatePropertyTranslate: (group, language) => dispatch(tourPropertyAction.updatePropertyTranslate(group, language)),
        deletePropertyTranslate: (group, refreshParams) => dispatch(tourPropertyAction.deletePropertyTranslate(group, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ActionComponent)));
